import PropTypes from 'prop-types'

export const BrandShape = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  brandPageUrl: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    seoDescription: PropTypes.string,
    seoTitle: PropTypes.string,
  }),
}

export const GuidesShape = {
  featuredImage: PropTypes.shape({
    description: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  id: PropTypes.string,
  meta: PropTypes.shape({
    topics: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        slug: PropTypes.string,
      })
    ),
  }),
  slug: PropTypes.string,
  teaser: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
}

export const CatalogCategoryShape = {
  frequentlyAskedQuestions: PropTypes.arrayOf(PropTypes.object).isRequired,
  guides: PropTypes.arrayOf(PropTypes.shape(GuidesShape)),
  guideIds: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.number.isRequired,
  imageUrl: PropTypes.string,
  isSortable: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  teaser: PropTypes.shape({
    imageUrl: PropTypes.string,
    text: PropTypes.string.isRequired,
  }),
  title: PropTypes.string.isRequired,
  urlSlug: PropTypes.string.isRequired,
}

CatalogCategoryShape.children = PropTypes.arrayOf(
  PropTypes.shape(CatalogCategoryShape)
)

export const CuratedProductCollectionShape = {
  id: PropTypes.string.isRequired,
  teaser: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      brand: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      image: PropTypes.shape({
        thumbnailUrl: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      price: PropTypes.shape({
        current: PropTypes.number.isRequired,
        msrp: PropTypes.number,
      }),
      rating: PropTypes.number,
      reviewCount: PropTypes.number,
    })
  ).isRequired,
}

export const FeatureFlagsShape = PropTypes.object

export const ProductFiltersShape = {
  available: PropTypes.bool,
}

export const ProductVariantShape = {
  attributes: PropTypes.object,
  availableOnBabylist: PropTypes.bool,
  id: PropTypes.number,
  image: PropTypes.shape({
    thumbnail: PropTypes.string,
    url: PropTypes.string,
  }),
  name: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
}

export const HeroProductShape = {
  brand: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  description: PropTypes.string,
  genericProductId: PropTypes.number.isRequired,
  heroPath: PropTypes.string.isRequired,
  heroUrl: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  images: PropTypes.shape({
    thumbnailUrl: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  isAvailableOnBabylist: PropTypes.bool,
  isCashFund: PropTypes.bool,
  isCrowdFund: PropTypes.bool,
  isElectronicGiftCard: PropTypes.bool,
  isFavor: PropTypes.bool,
  isGiftCard: PropTypes.bool,
  maxPrice: PropTypes.string,
  minPrice: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.object,
  pricing: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
    msrp: PropTypes.number,
  }),
  productBadge: PropTypes.shape({
    title: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
  }),
  productOptionsCta: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.shape(ProductVariantShape)),
}

export const SortParamsShape = {
  sort: PropTypes.string,
  order: PropTypes.string,
}
